const Row = ({ items, outline }) => (
  <div className="flex shrink-0 items-center">
    {items.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className={`font-wide font-black uppercase text-5xl sm:text-7xl lg:text-8xl tracking-tight whitespace-nowrap ${outline && i % 2 ? "text-outline" : "text-ink"}`}>
          {t}
        </span>
        <span className="mx-6 sm:mx-10 h-3 w-3 sm:h-4 sm:w-4 rotate-45 bg-brass shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = ({ items, outline = true }) => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-ink/15 bg-porcelain py-8 sm:py-10" aria-hidden="true">
    <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
      <Row items={items} outline={outline} />
      <Row items={items} outline={outline} />
    </div>
  </div>
);
